import SpriteSymbol from "../../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/_svg-sprite-loader@5.2.1@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ts_trial_add",
  "use": "icon-ts_trial_add-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol viewBox=\"0 0 12 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ts_trial_add\">\n<path d=\"M6 1L6 11\" stroke=\"\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n<path d=\"M11 6L1 6\" stroke=\"\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol